import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../ProgressIndicator"

const ProductEditorTranslationContext = createContext(undefined)

export const ProductEditorTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.producteditor", {useSuspense: false})

    if (ready) {
        return (
            <ProductEditorTranslationContext.Provider value={t}>
                {children}
            </ProductEditorTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useProductEditorTranslation = () => {
    return useContext(ProductEditorTranslationContext)
}